import axios from "axios";

export const statsAPI = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/stats/`,
});
